"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.array.find");require("regenerator-runtime/runtime");var _asyncToGenerator2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator"));require("core-js/modules/es6.function.name");












































































































var _user = require("@/utils/user");
var _aliOss = _interopRequireDefault(require("@/utils/aliOss"));
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      droplist: [], title: '', newadd: false, addData: { id: '', otaVersionId: '', otaVersionName: '', url: '', file: '', remark: '' }, defaultData: { id: '', otaVersionId: '', otaVersionName: '', url: '', file: '', remark: '' }, searchData: { otaVersionId: '', // 当前页码
        page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'otaVersionName', label: '文件名称', isShow: true }, { prop: 'url', label: '下载地址', isShow: true }, { prop: 'remark', label: '备注', isShow: true }, { prop: 'createTime', label: '创建时间', isShow: true, formatter: _formatter.dateFormatter }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'operatorName', label: '创建者', isShow: true }], rules: { otaVersionName: [{ required: true, message: '请输入文件名称', trigger: 'blur' }], url: [{ required: true, message: '请选择上传的文件', trigger: 'blur' }] } };}, mounted: function mounted() {var self = this;self.searchData.otaVersionId = self.$route.params.parentId;self.addData.otaVersionId = self.$route.params.parentId;self.defaultData.otaVersionId = self.$route.params.parentId;self.init();}, methods: { init: function init() {var self = this;self.getData('api/faOtaVersionUrl', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, beforeRemove: function beforeRemove(file, fileList) {console.log(file);var fileName = file.name;
      var confirm = '确定移除' + fileName + '？';
      return this.$confirm(confirm);
    },
    handleOnRemove: function handleOnRemove(file, fileList) {
      this.addData.url = '';
      this.$message('移除' + file.name + '成功');
    },
    onsuccess: function onsuccess(res) {
      var fileUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
      this.addData.url = fileUrl;
    },
    fnUploadRequest: function fnUploadRequest(option) {
      var path = 'xunfei/detail';
      _aliOss.default.ossUploadFile(option, path);
    },
    delMenu: function delMenu(item) {
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/faOtaVersionUrl/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    updateMenu: function updateMenu(item) {
      this.title = '修改';
      var self = this;
      this.addData = {
        id: item.id,
        otaVersionId: item.otaVersionId,
        otaVersionName: item.otaVersionName,
        url: item.url,
        remark: item.remark };

      self.newadd = true;
    },
    onSubmit: function onSubmit(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          var parems = new FormData();
          if (self.addData.remark == null) {
            self.addData.remark = '';
          }
          parems.append('id', self.addData.id);
          parems.append('otaVersionId', self.addData.otaVersionId);
          parems.append('otaVersionName', self.addData.otaVersionName);
          parems.append('url', self.addData.url);
          parems.append('remark', self.addData.remark);
          self.postData('/api/faOtaVersionUrl', parems, function (res) {
            self.$message({
              message: '新增成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.addData.details = self.poplistData;
          self.postData('/api/faOtaVersionUpdateContent/', self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    getFile: function getFile(event) {
      var self = this;
      self.addData.file = event.target.files[0];
      var OSS = require('ali-oss');
      var client = new OSS({
        region: 'oss-cn-hangzhou',
        accessKeyId: 'LTAI4FwjzDNtBJGzxDaQ5dQm',
        accessKeySecret: 'tPRcQ5u5IiQSAQkbfNWj4PKjxoJ4EJ',
        bucket: 'familyiot' });

      // 海外地址
      // var hkName = 'hk'
      // 国内正式环境地址
      // var prodName = 'prod'
      // 测试环境地址
      // var testName = 'test'
      // 开发环境地址
      var devName = 'dev';
      var url = devName + '/ota/version/' + self.searchData.otaVersion + '/' + self.addData.file.name;
      self.addData.url = 'https://cdn-tech.cozzia.com.cn' + '/' + url;function
      put() {return _put.apply(this, arguments);}function _put() {_put = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.prev = 0;_context.next = 3;return (

                    client.put(url, self.addData.file));case 3:_context.next = 8;break;case 5:_context.prev = 5;_context.t0 = _context["catch"](0);

                  console.log('e', _context.t0);case 8:case "end":return _context.stop();}}}, _callee, null, [[0, 5]]);}));return _put.apply(this, arguments);}


      put();
    },
    changeproductFun: function changeproductFun(data) {
      var obj = {};
      obj = this.droplist.find(function (item) {
        return item.name === data;
      });
      this.addData.locale = obj.name;
      this.addData.localeName = obj.type;
    },
    onCencal: function onCencal() {
      this.$refs.addForm.resetFields();
      this.newadd = false;
    },
    closeDiglog: function closeDiglog() {
      this.$refs['addForm'].resetFields();
      this.newadd = false;
    },
    returnFun: function returnFun() {
      // 返回上一级
      // this.$router.push('/xunfei/firmware')
      this.$store.dispatch('/xunfei/firmware', this.$route);
      // 返回上一步路由
      this.$router.go(-1);
    } } };exports.default = _default;